import { render, staticRenderFns } from "./return-handle.vue?vue&type=template&id=d4ae8670&scoped=true"
import script from "./return-handle.vue?vue&type=script&lang=ts"
export * from "./return-handle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae8670",
  null
  
)

export default component.exports